module.exports = __webpack_public_path__ + "img/buy-icon3-en.4057eec.png";